import PropTypes from 'prop-types';

import styles from './CalendarTitle.scss';

import { dateUtils } from '../../../../../routes/utils';

export const CalendarTitle = ({ month, year }) => (
  <strong className={styles.Calendar__title}>{`${dateUtils.getMonthFullName(
    month,
  )} ${year}`}</strong>
);

CalendarTitle.propTypes = {
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
};
